import {Dispatch, SetStateAction, useEffect, useRef } from "react";
import {AnalyzeSearchParamType} from "../interface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {SubmitHandler, useForm} from "react-hook-form";

interface PropsType {
    searchParam: AnalyzeSearchParamType
    setSearchParam: Dispatch<SetStateAction<AnalyzeSearchParamType>>
}

export default function Filter({searchParam, setSearchParam}: PropsType) {
    const {goToNavigation} = useGoToNavigation();

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: searchParam,
    });

    const onSubmit: SubmitHandler<AnalyzeSearchParamType> = (submitData) => {
        goToNavigation(`inventory/analyze/list`, {}, false)
        setSearchParam({...submitData });
    };

    const startAt = watch("startAt");
    const endAt = watch("endAt");

    useEffect(() => {
        if (startAt && endAt && startAt > endAt) {
            setValue("endAt", startAt);  // startAt이 endAt보다 크다면 endAt을 startAt으로 변경
        }
    }, [startAt, endAt, setValue]);

    return <form className="fiter_wrap" onSubmit={handleSubmit(onSubmit)}>
        <div className="fiter_top">
            <h3 className="filter_heading">재고 분석 검색</h3>
            <div className="filter_toolbar"></div>
        </div>
        <div className="row">
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">상태</label>
                    <select className="form-select w-150px"
                            {...register("stateOption")}
                    >
                        <option value={"0"}>전체</option>
                        <option value={"1"}>주문필요</option>
                    </select>
                </div>
            </div>
            <div className="col-6">
                <div className="frm_row">
                    <label htmlFor="" className="form-label frm_label">검색어</label>
                    <div className="frm_field">
                        <select className="form-select w-150px"
                                {...register("keywordType")}
                        >
                            <option value={"1"}>전체</option>
                            <option value={"2"}>벤더</option>
                            <option value={"3"}>카테고리</option>
                            <option value={"4"}>품목</option>
                            <option value={"5"}>규격</option>
                        </select>
                        <input type="text" className="form-control w-250px"
                               {...register("keyword")}
                        />
                        <button className="btn btn-info btn_search">
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className="row mt-10px">
            <div className="col-6">
                <div className="frm_row">
                    <label htmlFor="" className="form-label frm_label">입출고기간</label>
                    <div className="frm_field">
                        <div className="frm_field input_date">
                        <input
                                    type="date"
                                    className="form-control"
                                    max={getValues("endAt")}
                                    {...register("startAt")}
                                />
                                <span className="txt_range">~</span>
                                <input
                                    type="date"
                                    className="form-control me-0"
                                    min={getValues("startAt")}
                                    max="9999-12-31"
                                    {...register("endAt")}
                                />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
}